import React, { type FC, memo } from "react";
import type { PriceType } from "../../../../../../../common-deprecated/types/CommonTypes";
import { getAemPriceConfig } from "../../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { useCarConfigSelector } from "../../../../redux/store";
import { AemFmComponent } from "../../../../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import CashPrice from "./CashPrice";
import MonthlyPrice from "./MonthlyPrice";

type PriceProps = {
    price: PriceType;
    financeItemId?: string;
    forceCashPrice?: boolean;
    showDiscountPrice?: boolean; // Use the discount price instead of the cash price to show the price with discounts
    readyToShow?: boolean;
    showZeroPrice?: boolean;
    showDiscountHorizontal?: boolean; // Used to show the discount price horizontally instead of the standard vertical layout
    customFormatting?: string;
};

const Price: FC<PriceProps> = (props) => {
    const {
        price,
        financeItemId,
        forceCashPrice,
        showDiscountPrice,
        readyToShow = true,
        customFormatting,
        showZeroPrice = false,
        showDiscountHorizontal = false,
    } = props;
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const modelCode = useCarConfigSelector((state) => state.car.model.internalCode);
    const financeOption = useCarConfigSelector((state) => state.utils.financeOption);
    const tradeInVehiclePrice = useCarConfigSelector((state) => state.tradeInAemExternalData.data?.vehicleValue);
    const financeInfo = useCarConfigSelector((state) => state.finance.info);

    const monthly = useCarConfigSelector((state) => {
        if (financeItemId) {
            if (financeItemId === "total") {
                return Number(state.finance.total);
            } else {
                return price.monthly;
            }
        } else {
            return price.monthly;
        }
    });

    const renderedPrice = { ...price, monthly };
    const priceConfig = getAemPriceConfig(commonSettings, AemFmComponent.Carconfig, modelCode);

    // If a trade-in vehicle price is present remove it from the cash total price.
    if (financeItemId === "total" && tradeInVehiclePrice && renderedPrice.discount > tradeInVehiclePrice) {
        renderedPrice.discount -= tradeInVehiclePrice;
    }

    return (
        <>
            {readyToShow && (
                <span>
                    {(financeOption === "cash" || forceCashPrice) && (
                        <CashPrice
                            price={renderedPrice}
                            priceConfig={priceConfig}
                            showDiscountPrice={showDiscountPrice}
                            customFormatting={customFormatting}
                            showZeroPrice={showZeroPrice}
                            showDiscountHorizontal={showDiscountHorizontal}
                        />
                    )}
                    {financeOption === "monthly" && !forceCashPrice && (
                        <MonthlyPrice
                            price={renderedPrice}
                            financeInfo={financeInfo}
                            modelCode={modelCode}
                            showZeroPrice={showZeroPrice}
                        />
                    )}
                </span>
            )}
        </>
    );
};

export default memo(Price);
